var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Topbar',{attrs:{"id":"top-nav"}}),_c('about-vue',{staticStyle:{"margin-top":"-280px"},attrs:{"id":"about-me"}}),_c('Projects',{attrs:{"id":"projects"}}),_c('Footer',{attrs:{"id":"footer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }